import {useState} from "react";
import {getFromLocalStorageWithDefault, saveToLocalStorage} from "./localStorageZugriff";
import ConfigUtil from "./ConfigUtil";
import FetchUtil from "./FetchUtil";

// Die Wahl zwischen altem und neuem Design gilt gemeinsam für alle öffentlichen Seiten (Events, Veranstalter, Turnier)
// und wird dauerhaft im Browser gemerkt. Ohne gespeicherte Wahl wird die alte Ansicht angezeigt.
const KEY_NEUE_ANSICHT = "dh_public_tournament_neue_ansicht";

const ladeNeueAnsicht = () => getFromLocalStorageWithDefault(KEY_NEUE_ANSICHT, false) === true;

// Für die Auswertung in Influx, wie viele auf die neue bzw. alte Ansicht wechseln. Fehler sind für den Nutzer unwichtig.
const meldeWechsel = (neueAnsicht) => {
    FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.public + "/ansichtwechsel/" + (neueAnsicht ? "neu" : "alt"),
        {},
        () => {},
        responseNotOk => console.log("Ansichtwechsel konnte nicht gemeldet werden: " + responseNotOk.message),
        error => console.log("Ansichtwechsel konnte nicht gemeldet werden: " + error));
}

export function useOeffentlicheAnsicht() {

    const [neueAnsicht, setNeueAnsicht] = useState(ladeNeueAnsicht);

    const wechseln = () => {
        const neuerWert = !neueAnsicht;
        saveToLocalStorage(KEY_NEUE_ANSICHT, neuerWert);
        setNeueAnsicht(neuerWert);
        window.scrollTo(0, 0);
        meldeWechsel(neuerWert);
    }

    return {neueAnsicht, wechseln};
}
